import AttributeCommand from '@ckeditor/ckeditor5-basic-styles/src/attributecommand';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

export class IpexAiLoading extends Plugin {
    init() {
        const editor = this.editor;
        const ipexAiLoading = 'ipexAiLoading';
        editor.ui.componentFactory.add(ipexAiLoading, () => {
            const button = new ButtonView();
            button.set({
                withText: false,
                icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path fill="#000000" stroke="#000000" stroke-width="15" transform-origin="center" d="m148 84.7 13.8-8-10-17.3-13.8 8a50 50 0 0 0-27.4-15.9v-16h-20v16A50 50 0 0 0 63 67.4l-13.8-8-10 17.3 13.8 8a50 50 0 0 0 0 31.7l-13.8 8 10 17.3 13.8-8a50 50 0 0 0 27.5 15.9v16h20v-16a50 50 0 0 0 27.4-15.9l13.8 8 10-17.3-13.8-8a50 50 0 0 0 0-31.7Zm-47.5 50.8a35 35 0 1 1 0-70 35 35 0 0 1 0 70Z"><animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="0.5" values="0;120" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform></path></svg>`,
                class: 'ck-ipex-ai-loading-button',
                label: ipexAiLoading,
                isVisible: true
            });

            // we need to catch this command later
            editor.commands.add(ipexAiLoading, new AttributeCommand(editor, ipexAiLoading));

            // button execution
            button.on('execute', () => {
                editor.fire(ipexAiLoading);
            });

            return button;
        });
    }
}
